"use client";
//#region packages/@mantine/core/src/components/AppShell/AppShell.module.css
var AppShell_module_default = {
	"root": "m_89ab340",
	"navbar": "m_45252eee",
	"aside": "m_9cdde9a",
	"header": "m_3b16f56b",
	"main": "m_8983817",
	"footer": "m_3840c879",
	"section": "m_6dcfc7c7"
};
//#endregion
export { AppShell_module_default as default };

//# sourceMappingURL=AppShell.module.mjs.map